import type {IDbUserSettingsStorage, UserSettings} from '@igp/shared/user-settings';
import {dbUserSettingsStorageConfig} from '@igp/shared/user-settings';
import type {Table} from 'dexie';
import Dexie from 'dexie';

export class DbContext extends Dexie implements IDbUserSettingsStorage {
    userSettings: Table<UserSettings, number>;

    constructor() {
        super('BOAgent');
        this.version(1).stores({
            ...dbUserSettingsStorageConfig,
        });
    }
}

export function initDatabase() {
    return new DbContext();
}
